import { getSite } from '../infrastructure/site/SiteProvider';
import { MenuItemDto } from '../uiComponents/input/FormGroups';

export function getSkoleaarList(): MenuItemDto[] {
    const startAar = 2017;
    const currentAar = new Date().getFullYear() + 1;

    const list: MenuItemDto[] = new Array();
    for (var aar = startAar; aar <= currentAar; aar++) {
        const item = new MenuItemDto(aar, getAarNavn(aar));
        list.push(item);
    }

    return list;
}

export function getSkoleaarFromDate(date: Date): number {
    const dateObject = new Date(date);
    const august = 8;

    if (dateObject.getMonth() + 1 < august) {
        return dateObject.getFullYear() - 1;
    }
    return dateObject.getFullYear();
}

export function getAarNavn(aar: number): string {
    const naesteAar = aar + 1;
    return getSite().kortNavn + ' ' + aar + '/' + naesteAar;
}

export function getSkoleAar(date: Date): string {
    const skoleaar = getSkoleaarFromDate(date);
    const naesteAar = skoleaar + 1;
    return skoleaar + '/' + naesteAar;
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/SkoleAar.ts